import type { SiteBriefStatusType } from '../api.types';

export const SITE_BRIEF_STATUS_LABELS: Record<SiteBriefStatusType, string> = {
  init: 'Init',
  gather_requirements: 'Gather requirements',
  suggest_requirements: 'Suggestions',
  build_site_structure: 'Site structure',
  generate_site_core: 'Site core',
  fulfill_vibe_blocks: 'Vibe blocks',
};
